// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"3360e4a5","344":"6731e563","689":"c39606fe"}[chunkId] + ".chunk.css";
};